import { ssFetchJSON } from './ssFetch';
import { RECOMMENDATIONS_ENGINE_PREFIX, RECOMMENDATIONS_SOURCE_URL } from '../config';

export const getRecommendationsData = <T>(namespace: string, path: string | number) => {
  const BASE_URL = `${RECOMMENDATIONS_SOURCE_URL}${namespace}/${RECOMMENDATIONS_ENGINE_PREFIX}`;
  const url = `${BASE_URL}/${path}.json`;
  return ssFetchJSON(url) as unknown as T;
};
